import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import CashSVG from '../../common/svgs/CashSVG';
import CardsSVG from '../../common/svgs/CardsSVG';
import LoyaltyIconSvg from '../../common/svgs/LoyaltyIconSVG';
import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import { loadPromotionSearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightPromotionSummarySearch } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import AutoCompleteSearch from '../../central/autosearch/AutoCompleteSearch';
import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';

class PromotionSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        promotionId: '',
        promotionName: '',
        orderTypeId: '',
        paymentTypeId: '',
        discountTypeId: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        if(this.props.isRestaurantInsight) {
            this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId);
        } else {
            this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId);
        } 
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId } = this.props;
        if(this.props.isRestaurantInsight) {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate,
                page: 0
            }, () => this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId));
        } else {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate,
                page: 0
            }, () => this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId)); 
        }
    }

    handlePageChange = pageNumber => {
        const { restaurantId, customerId } = this.props;
        if(this.props.isRestaurantInsight) {
            this.setState({
                page: (pageNumber - 1)
            }, () => this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId));
        } else {
            this.setState({
                page: (pageNumber - 1)
            }, () => this.props.loadPromotionSearch(restaurantId, customerId, this.state.page, this.state.promotionId, this.state.promotionName,
                this.state.fromDate, this.state.toDate, this.state.orderTypeId, this.state.paymentTypeId, this.state.discountTypeId));
        }
    }

    renderProductSummaryTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;
        if(this.props.isRestaurantInsight) {
            return( 
                <tr>
                    <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.promotion')}</th>
                    <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.timesRedeemed')}</th>
                    <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
                </tr>
            )
        } else {
            return (
                <tr>
                    <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.promotion')}</th>
                    <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalAmount')}</th>
                    <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.date')}</th>
                    <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.orderType')}</th>
                    <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.paymentType')}</th>
                    <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.promoCode')}</th>
                    <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.freeDelivery')}</th>
                </tr>
            );
        }
        
    }

    renderTableContent = () => {
        if(this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) {
            return this.props.restaurantInsightPromotionSummary.content.map(item => {
                return this.renderSingleItem(item);
            })
        } else {
            return this.props.customerInsightPromotionSearch.content.map(item => {
                return this.renderSingleItem(item);
            })
        }
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;

        if(this.props.isRestaurantInsight) {
            return (
                <tr>
                    <td style={{ ...tableDetail, ...firstRow }}>{item.promotionName}</td>
                    <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                    <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.discountAmount, currency)}</td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td style={{ ...tableDetail, ...firstRow }}>{item.promotionName}</td>
                    <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.discountAmount, currency)}</td>
                    <td style={{ ...tableDetail, ...textCenter }}>{item.date}</td>
                    <td style={{ ...tableDetail }}>{this.renderOrderSVGIcon(item.orderType)}&nbsp;&nbsp;{this.renderOrderTypeName(item.orderType)}</td>
                    <td style={{ ...tableDetail }}>{this.renderPaymentSVGIcon(item.paymentType)}&nbsp;&nbsp;{this.renderPaymentTypeName(item.paymentType)}</td>
                    <td style={{ ...tableDetail, ...textCenter }}>{item.promoCode ? item.promoCode : "-"}</td>
                    <td style={{ ...tableDetail, ...textCenter }}>{item.freeDelivery ? i18n.t('screens:customerInsightScreen.yes') : i18n.t('screens:customerInsightScreen.no')}</td>
                </tr>
            );
        }
    }

    renderOrderSVGIcon = type => {
        switch (type) {
            case "Delivery": return <DeliverySVG width={16} height={16} fill={'#0288D1'} />;
            case "Collection": return <PickUpSVG width={16} height={16} fill={'#0288D1'} />
            case "Curbside": return <CurbsideSVG width={16} height={16} fill={'#0288D1'} />
            case "Dine In": return <InStoreSvg width={16} height={16} fill={'#0288D1'} />
            default: return null
        }
    }

    renderOrderTypeName = type => {
        switch (type) {
            case "Delivery": return i18n.t('screens:customerInsightScreen.Delivery');
            case "Collection": return i18n.t('screens:customerInsightScreen.Collection');
            case "Curbside": return i18n.t('screens:customerInsightScreen.Curbside');
            case "Dine In": return i18n.t(`screens:restaurantsMainContainer.instore`);
            default: return null
        }
    }

    renderPaymentSVGIcon = type => {
        switch (type) {
            case "Credit card": return <CardsSVG width={15} height={15} fill={'#0288D1'} />
            case "Cash": return <CashSVG width={15} height={15} fill={'#0288D1'} />
            case "Loyalty": return <LoyaltyIconSvg width={15} height={15} fill={'#0288D1'} />
            default: return null
        }
    }

    renderPaymentTypeName = type => {
        switch (type) {
            case "Credit card": return i18n.t('screens:customerInsightScreen.creditCard');
            case "Cash": return i18n.t('screens:customerInsightScreen.cash');
            case "Loyalty": return i18n.t('screens:customerInsightScreen.loyalty');
            default: return null
        }
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderPromotionNameAutoselect()}
                    {this.renderOrderTypeDropdown()}
                    {this.renderPaymentTypeDropdown()}
                    {!this.props.isRestaurantInsight && this.renderDiscountTypeDropdown()}
                </Row>
            </Container>
        );
    }

    changeState = (e, promotion) => {
        if (promotion) {
            this.setState({ promotionId: promotion.id, promotionName: promotion.name })
        } else {
            this.setState({ promotionId: '', promotionName: e.target.value })
        }
    }

    renderPromotionNameAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <AutoCompleteSearch
                    inputId='name'
                    inputName='name'
                    placeholder={i18n.t('screens:customerInsightScreen.promotionName')}
                    inputValue={this.state.promotionName}
                    inputStyle={{}}
                    changeState={this.changeState}
                    searchValues={this.props.customerInsightPromotionNames} />
            </ Col>
        );
    }

    renderOrderTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="orderTypeId"
                    id="orderTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectOrderType')}
                    value={this.state.orderTypeId}
                    onChange={(e) => this.setState({ orderTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectOrderType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.Delivery')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.Collection')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.Curbside')}</option>
                    <option value='5'>{i18n.t(`screens:restaurantsMainContainer.instore`)}</option>
                </Input>
            </ Col>
        );
    }

    renderPaymentTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="paymentTypeId"
                    id="paymentTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectPaymentType')}
                    value={this.state.paymentTypeId}
                    onChange={(e) => this.setState({ paymentTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectPaymentType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.creditCard')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.cash')}</option>

                </Input>
            </ Col>
        );
    }

    renderDiscountTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0, paddingRight: 0 }} >
                <Input
                    type="select"
                    name="discountTypeId"
                    id="discountTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectDiscountType')}
                    value={this.state.discountTypeId}
                    onChange={(e) => this.setState({ discountTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectDiscountType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.priceDiscount')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.freeProduct')}</option>
                    <option value='3'>{i18n.t('screens:customerInsightScreen.comboDeal')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.loyalty')}</option>
                    <option value='5'>{i18n.t('screens:customerInsightScreen.marketingAutomation')}</option>
                </Input>
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;
        const customerInsightPromotionSummaryNumber = this.props.customerInsightPromotionSummary ? this.props.customerInsightPromotionSummary.number : null;
        const customerInsightPromotionSummaryElements = this.props.customerInsightPromotionSummary ? this.props.customerInsightPromotionSummary.totalElements : null;
        const promotionSummaryNumber = (this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) ? this.props.restaurantInsightPromotionSummary.number : customerInsightPromotionSummaryNumber;
        const promotionSummaryTotalElements = (this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) ? this.props.restaurantInsightPromotionSummary.totalElements : customerInsightPromotionSummaryElements;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={promotionSummaryNumber + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={promotionSummaryTotalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="PromotionSearch" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderProductSummaryTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightPromotionSearch: state.customerInsightPromotionSearch,
        customerInsightPromotionNames: state.customerInsightPromotionNames,
        restaurantInsightPromotionSummary: state.restaurantInsight.promotionSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadPromotionSearch,
    loadRestaurantInsightPromotionSummarySearch })(PromotionSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/PromotionSearch.js